/* eslint-disable jsx-a11y/anchor-has-content */
import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {gql} from 'apollo-boost';
import {Query} from 'react-apollo';

const GET_COMPONENT = gql`
query paragraphRevisionById($id: String!) {
  paragraphById: paragraphRevisionById(id: $id) {
    ... on Paragraph {
      ... on Paragraph {
        ... on ParagraphMobileComponentAwardList {
          fieldAwardItems {
            ... on FieldParagraphFieldAwardItems {
              entity {
                ... on ParagraphInnerAward {
                  fieldTxtHeadline
                  fieldObjectImgMedia {
                      entity {
                        ... on MediaImage {
                          fieldMediaImage {
                            width
                            height
                            url
                            alt
                            title
                          }
                        }
                      }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}
`;

class MobileComponentAwardList extends Component {

    static propTypes = {
        id: PropTypes.number.isRequired,
        markComponentLoadedAs: PropTypes.func.isRequired,
    };

    static defaultProps = {
        componentIndex: null
    };

    render() {
        const {id, markComponentLoadedAs} = this.props;

        return (
            <Query asyncMode query={GET_COMPONENT} variables={{ id }}>
                {({ loading, error, data }) => {
                    if (loading) return null;
                    if (error) {
                        markComponentLoadedAs(id, true);
                        return <div>{error}</div>;
                    }

                    const field = data.paragraphById;
                    const awards = field.fieldAwardItems && field.fieldAwardItems.length ? field.fieldAwardItems.map(component => component.entity) : [];

                    markComponentLoadedAs(id, true);

                    if (!awards.length) return null;

                    return (
                        <ul className="yitm__SplitList">
                            {awards.map(award => (
                                <li>
                                    <div className="container">
                                        <div className="yitm__SplitListText">
                                            {award.fieldTxtHeadline ? (<h3>{award.fieldTxtHeadline}</h3>) : null}
                                        </div>
                                        <div className="yitm__SplitListImage">
                                            {award.fieldObjectImgMedia && award.fieldObjectImgMedia.entity && award.fieldObjectImgMedia.entity.fieldMediaImage && award.fieldObjectImgMedia.entity.fieldMediaImage.url ? (
                                                <img src={award.fieldObjectImgMedia.entity.fieldMediaImage.url} alt={award.fieldObjectImgMedia.entity.fieldMediaImage.alt}/>
                                            ) : null}
                                        </div>
                                    </div>
                                </li>
                            ))}
                        </ul>
                    );
                }}
            </Query>
        )
    }

}


export default MobileComponentAwardList;



// WEBPACK FOOTER //
// ./frontend/components/YITMMobile/MobileComponentAwardList.jsx